<!-- Modal LOGIN-->
<div class="modal fade contenedor-modal" id="modalLogin" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-body p-0">
                <app-login-form [esModal]="true" (resultEvent)="onLogin($event)"
                    (goRegister)="abrirModal(modalRegister)">
                </app-login-form>
            </div>
        </div>
    </div>
</div>

<!-- Modal REGISTRO-->
<div class="modal fade contenedor-modal" id="modalRegister" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-body p-0">
                <app-register-form [esModal]="true" (resultEvent)="onRegister($event)"
                    (goLogin)="abrirModal(modalLogin)">
                </app-register-form>
            </div>
        </div>
    </div>
</div>

<!-- Modal TARJETAS-->
<div class="modal fade contenedor-modal" id="modalPayment" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content" *ngIf="objetoPurchase">
            <div class="modal-body p-0">
                <app-payment-options [info]="infoCompra" [typeTransaction]="objetoPurchase.type"
                    [objetoPurchase]="objetoPurchase" [ppv]="false"></app-payment-options>
            </div>
        </div>
    </div>
</div>

<!-- Modal CONDICIONES-->
<div class="modal fade contenedor-modal" id="modalConditions" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-body p-0">
                <!-- <app-payment-options
          [typeTransaction]="objetoPurchase.type"
          [objetoPurchase]="objetoPurchase"
        ></app-payment-options> -->

                <app-conditions (onClose)="onCondiciones($event)"></app-conditions>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-12 mt-5">
        <div class="row">
            <div class="col-12">
                <div class="AFO_Container text-white mb-4">

                    <!-- HEADER -->
                    <div class="AFO_Container_header">
                        <section class="AFO_Container_header-left">
                            <h1>DISFRUTA Y APOYA<br>AL CINE URUGUAYO</h1>
                            <p>Uruguay tuvo su propio Georges Mélies y se llamó Félix Oliver, el pionero del cine
                                uruguayo. Ahora en la
                                plataforma que lleva su nombre podés contratar el
                                <span>
                                    Plan Félix Oliver.
                                </span><br>
                                Encontrá cine uruguayo, el viejo y el nuevo, largos, cortos y mediometrajes,
                                documentales y ficciones,
                                series, entrevistas, fragmentos de material de archivo, posters, reseñas e
                                información sobre equipos de
                                trabajo.
                            </p>
                            <a class="felixBotones" href="#" (click)="clickSub($event, 1)">Suscribite ahora</a>
                        </section>
                        <section class="AFO_Container_header-right">
                            <h2><span>Felix Oliver</span>,<br>pionero del cine uruguayo</h2>
                        </section>
                    </div>

                    <!-- LOADING -->
                    <div class="card-body text-center" *ngIf="loading">
                        <div class="spinner-border mt-2 text-secondary spinner-color"
                            style="width: 1.5rem; height: 1.5rem" role="status" *ngIf="loading">
                            <span class="sr-only">Cargando...</span>
                        </div>
                    </div>

                    <!-- TARJETAS FO -->
                    <div class="AFO_Container_planes-limitados" *ngIf="!loading">
                        <section class="AFO_Container_planes-limitados-card">
                            <h2>Plan Mensual <span>Félix Oliver</span></h2>
                            <hr>
                            <p class="AFO_Container_planes-limitados-card-par">Acceso ilimitado a películas del catálogo
                                y un costo adicional bonificado de $90 para
                                ver los estrenos.</p>
                            <section class="AFO_Container_planes-limitados-card-precio">
                                <label>${{plans[1].price}} <span>/mes *</span></label>
                                <a href="#" id="mensualFelixOliver" (click)="clickSub($event, 1)">ELEGÍ MENSUAL</a>
                            </section>
                            <hr>
                            <p class="AFO_Container_planes-limitados-card-ptext">*El pago se hace a través de tarjeta
                                de crédito VISA, OCA,
                                Cabal, Creditel o
                                Créditos Directos. No está incluida en esta modalidad la tarjeta Mastercard. La
                                suscripción tiene un mínimo
                                de 3 meses.</p>
                        </section>

                        <section class="AFO_Container_planes-limitados-card">
                            <h2>Plan Anual <span style="color:#FF0066; font-weight:700;">Félix Oliver</span></h2>
                            <hr>
                            <p class="AFO_Container_planes-limitados-card-par">Acceso ilimitado a películas del catálogo
                                y un costo adicional bonificado de $90 para
                                ver los estrenos.</p>
                            <section class="AFO_Container_planes-limitados-card-precio">
                                <label>${{plans[1].anualprice}} <span>/pago único *</span></label>
                                <a href="#" id="anualFelixOliver" (click)="clickSub($event, 2)">ELEGÍ ANUAL</a>
                            </section>
                            <hr>
                            <p class="AFO_Container_planes-limitados-card-ptext">*El pago se hace a través de tarjeta
                                de crédito VISA, OCA,
                                Cabal, Creditel o
                                Créditos Directos. No está incluida en esta modalidad la tarjeta Mastercard</p>
                        </section>
                    </div>

                    <div class="AFO_Container_planes-tituloil" *ngIf="!loading">
                        <h2> Mirá contenidos ilimitados</h2>
                        <p>Largometrajes, cortometrajes, materiales de archivo, series y conferencias.</p>
                    </div>

                    <!-- TARJETAS NORMALES -->
                    <div class="AFO_Container_planes-ilimitados" *ngIf="!loading">
                        <section class="AFO_Container_planes-ilimitados-card">
                            <section class="AFO_Container_planes-ilimitados-card-title">
                                <h2>Plan Mensual</h2>
                                <img src="../../../assets/img/logos_cinemateca/Logo completo negro.png"
                                    alt="Logo Cinemateca">
                            </section>
                            <hr>
                            <p class="AFO_Container_planes-ilimitados-card-par">Contenido ilimitado a +Cinemateca<br>y a
                                <span>Félix
                                    Oliver.</span>
                            </p>
                            <section class="AFO_Container_planes-ilimitados-card-precio">
                                <label>${{plans[0].price}} <span>/mes *</span></label>
                                <a href="#" id="mensualMasCinemateca" (click)="clickSub($event, 3)">ELEGÍ MENSUAL</a>
                            </section>
                            <hr>
                            <p class="AFO_Container_planes-ilimitados-card-ptext">*El pago se hace a través de tarjeta
                                de crédito VISA, OCA,
                                Cabal, Creditel o
                                Créditos Directos. No está incluida en esta modalidad la tarjeta Mastercard. La
                                suscripción tiene un mínimo
                                de 3 meses. </p>
                        </section>

                        <section class="AFO_Container_planes-ilimitados-card">
                            <section class="AFO_Container_planes-ilimitados-card-title">
                                <h2>Plan Anual</h2>
                                <img src="../../../assets/img/logos_cinemateca/Logo completo negro.png"
                                    alt="Logo Cinemateca">
                            </section>
                            <hr>
                            <p class="AFO_Container_planes-ilimitados-card-par">Contenido ilimitado a +Cinemateca<br>y a
                                <span>Félix
                                    Oliver.</span>
                            </p>
                            <section class="AFO_Container_planes-ilimitados-card-precio">
                                <label>${{plans[0].anualprice}} <span>/pago único *</span></label>
                                <a href="#" id="anuallMasCinemateca" (click)="clickSub($event, 4)">ELEGÍ ANUAL</a>
                            </section>
                            <hr>
                            <p class="AFO_Container_planes-ilimitados-card-ptext">*El pago se hace a través de tarjeta
                                de crédito VISA, OCA,
                                Cabal, Creditel o
                                Créditos Directos. No está incluida en esta modalidad la tarjeta Mastercard.</p>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>